import Avatar from "@mui/material/Avatar";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import Box from "@mui/material/Box";
import "./ProfileAvatar.css";

function getInitials(fullName) {
  const nameParts = fullName.split(" ");
  const firstInitial = nameParts.length > 0 ? nameParts[0].charAt(0) : "";
 
  return `${firstInitial}`;
}

function ProfileAvatar({ showUserIcon, senderName }) {
  let senderinitialName = "";
  if (senderName) senderinitialName = getInitials(senderName);
  return (
    <>
      <Box
        className="position-relative profile-avatar"
        sx={{ width: "55px", height: "55px" }}
      >
        {/* <Box className="status" style={{ backgroundColor: "#12b76a" }}></Box> green dot*/}
        <Avatar
          sx={{
            height: "100%",
            width: "100%",
            backgroundColor: "#f2f4f7",
            color: "#667085",
          }}
        >
          {showUserIcon && <PeopleAltOutlinedIcon />}
          {!showUserIcon && <Box className="fw-bold">{senderinitialName}</Box>}
        </Avatar>
      </Box>
    </>
  );
}

export default ProfileAvatar;
